（广告组类型为受众）
1、商品

（广告组类型为商品投放）
1、商品
2、商品投放
3、否定商品投放

<template>
  <el-tabs
      :value="activeTab || 'adProduct'"
      @tab-click="tabClick"
      class="ad-tabs">
    <el-tab-pane name="adProduct" lazy>
      <template #label>广告</template>
      <app-sd-ad-product
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :campaign="proxyCampaign"
          :group="proxyGroup"
          table-name="sdAdGroupProduct"
      ></app-sd-ad-product>
    </el-tab-pane>
    <el-tab-pane
        name="adProductTarget" lazy>
      <template #label>商品投放</template>
      <app-sd-ad-product-target
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :campaign="proxyCampaign"
          :group="proxyGroup"
          table-name="sdAdCampaignProductTarget"
      ></app-sd-ad-product-target>
    </el-tab-pane>
    <el-tab-pane
        name="adNegTarget" lazy>
      <template #label>否定商品投放</template>
      <app-sd-ad-neg-target
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :campaign="proxyCampaign"
          :group="proxyGroup"
          table-name="sdAdGroupNegTarget"
      ></app-sd-ad-neg-target>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import AppSdAdProduct from "../components/ad-product/ad-product";
  import {getSdAdCampaignList, getSdAdGroupList} from "../../../../../api/ad";
  import {AdCampaignEnum, AdGroupEnum} from "../../common/enum";
  import {inCampaignMixin, inGroupMixin, initDateMixin, inMarketMixin, tabResizeMixin} from "../../common/mixin";
  import AppSdAdNegTarget from "../components/ad-neg-target/ad-neg-target";
  import AppSdAdProductTarget from "../components/ad-product-target/ad-product-target";

  export default {
    name: "app-sd-ad-group-manager",
    components: {
      AppSdAdProductTarget,
      AppSdAdNegTarget, AppSdAdProduct},
    mixins: [inMarketMixin, inCampaignMixin, inGroupMixin, tabResizeMixin, initDateMixin],
    props: {
      activeTab: {
        default: 'adProduct',
      }
    },
    created() {
    },
    data() {
      return {
        proxyCampaign: {},
        proxyGroup: {},
        AdGroupEnum: AdGroupEnum,
        AdCampaignEnum: AdCampaignEnum,
      }
    },
    methods: {
      campaignChange(campaignId) {
        getSdAdCampaignList({
          marketId: this.marketId,
          campaignId,
        })
          .then((data) => {
            this.proxyCampaign = data[0];
          })
          .complete(() => {});
      },
      groupChange(groupId) {
        getSdAdGroupList({
          marketId: this.marketId,
          campaignId: this.campaignId,
          groupId
        })
          .then((data) => {
            this.proxyGroup = data[0];
          })
          .complete(() => {});
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../common/common.scss';
  .ad-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .el-tabs__content{
      flex: 1;
    }
    /deep/ .el-tab-pane{
      height: 100%;
    }
  }
</style>
